import React from 'react';

import CategorySelectButtons from './CategorySelectButtons';
import MarkerDetails from './MarkerDetails';
import MapDetailsBox from './MapDetailsBox';

import { injectGoogleMapsScript } from './../../common/ScriptInjector';
import { compareArray } from './../../common/ArrayUtils';
import Chevron from '../../images/Chevron.js';
// import Dot from '../../images/Dot.js';

export default class LocationMap extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.messenger.subscribe('onMapLoaded', this.onMapLoaded.bind(this));
		injectGoogleMapsScript(this.props.apiKey, this.props.messenger, 'onMapLoaded');
	}

	componentDidUpdate(prevProps, prevState) {
		let comparisonResult = compareArray(prevProps.markers, this.props.markers, function (a, b) {
			return a.id === b.id;
		});

		if(!comparisonResult && this.props.markers > 10) {
			this.props.onRenderMarkers(this.props.markers, this.mapReference);
		}
	}

	onMapLoaded() {
		//reference to the dom element containing the map and the map instance
		this.domReference = document.getElementById(this.props.mapId);
		this.mapReference = new window.google.maps.Map(this.domReference, this.props.mapConfig);

		//for directions rendering
		this.directionService = new window.google.maps.DirectionsService();
		this.directionsDisplay = new window.google.maps.DirectionsRenderer({
			suppressMarkers: true,
		});

		this.directionsDisplay.setMap(this.mapReference);

		//set overlay
		let overlay = new window.google.maps.GroundOverlay(
			this.props.masterplanOverlay.imageUrl,
			this.props.masterplanOverlay.boundingCoords
		);
		overlay.setMap(this.mapReference);

		window.google.maps.event.addListener(overlay, 'click', function () {
			window.location = this.props.masterplanOverlayRedirect;
		}.bind(this));

		// render default markers
		this.props.onRenderMarkers(this.props.markers, this.mapReference);
	}

	render() {
		return (
			<div>
				<div id="locationMap" className={this.props.display.googleMap}>
					<div className="location-map-wrapper">
						<div id={this.props.mapId} className="location-map-container"></div>
						<MarkerDetails markerDetails={this.props.selectedMarker} visible={this.props.markerPopupIsVisible} onCloseButtonPressed={this.props.onMarkerPopupClose} messenger={this.props.messenger} />
					</div>
					<CategorySelectButtons markerGroups={this.props.markerGroups} onCategoryChange={this.props.onCategoryChange} onCategoryReset={this.props.onCategoryReset} />
				</div>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/modules/location/elements/LocationMap.js
 **/